import { API_BASE_URL } from "../../../config";
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomerLink from '../../Components/CustomerLink';

// ลูกค้าที่ค้างได้ — Vector 2026-10-02 tg_8961: ฝ่ายบัญชีกดเลือกว่าร้านไหนค้างจ่ายได้
// ร้านที่เปิดสวิตช์ไว้ = แอพ deliveryRE จะแสดงปุ่ม "ค้างจ่าย" ตอนขายร้านนั้น (ค้างทั้งบิล มีผลทันที)
const CreditCustomers = () => {
    const navigate = useNavigate();
    const [query, setQuery] = useState('');
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [busyUid, setBusyUid] = useState(null);

    const checkToken = useCallback(() => {
        const user = localStorage.getItem('user');
        if (!user) { navigate('/login'); return null; }
        return JSON.parse(user)?.token;
    }, [navigate]);

    // ไม่พิมพ์ค้นหา = แสดงเฉพาะร้านที่ค้างได้อยู่ตอนนี้ · พิมพ์ = ค้นทุกร้าน (ชื่อร้าน/ชื่อลูกค้า/รหัส)
    const load = useCallback(async (q) => {
        const token = checkToken();
        if (!token) return;
        setLoading(true);
        setError('');
        try {
            const term = (q || '').trim();
            const url = `${API_BASE_URL}/customer/api/customers/credit/search?` +
                (term ? `q=${encodeURIComponent(term)}` : 'onlyAllowed=true');
            const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
            if (!res.ok) throw new Error(res.status === 403 ? 'ไม่มีสิทธิ์ (ต้องเป็นฝ่ายบัญชี/ผู้จัดการ)' : `HTTP ${res.status}`);
            const data = await res.json();
            setRows(Array.isArray(data) ? data : []);
        } catch (e) {
            setRows([]);
            setError('โหลดรายชื่อไม่สำเร็จ: ' + (e.message || ''));
        } finally {
            setLoading(false);
        }
    }, [checkToken]);

    useEffect(() => { load(''); }, [load]);

    const toggle = async (row) => {
        const token = checkToken();
        if (!token) return;
        const next = !row.creditAllowed;
        setBusyUid(row.customerUid);
        try {
            const res = await fetch(`${API_BASE_URL}/customer/api/customers/regular/${encodeURIComponent(row.customerUid)}/credit`, {
                method: 'PUT',
                headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify({ creditAllowed: next }),
            });
            if (!res.ok) { const t = await res.text(); throw new Error(t || `HTTP ${res.status}`); }
            const saved = await res.json();
            // ใช้ค่าที่เซิร์ฟเวอร์ตอบกลับ ไม่ใช่ค่าที่เราส่ง — สวิตช์ต้องโชว์ความจริงในฐาน
            setRows(prev => prev.map(r => r.customerUid === row.customerUid ? { ...r, ...saved } : r));
        } catch (e) {
            alert('บันทึกไม่สำเร็จ: ' + (e.message || ''));
        } finally {
            setBusyUid(null);
        }
    };

    const rowStyle = { borderBottom: '1px solid #e9ecef', padding: '6px 12px' };
    const headerStyle = { background: '#f8f9fa', fontWeight: 700, borderBottom: '2px solid #dee2e6', padding: '8px 12px', fontSize: '13px', color: '#495057' };

    return (
        <div className="btc-container" style={{ maxWidth: '900px', margin: '0 auto' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '20px' }}>
                <button className="btc-btn" style={{ background: '#6c757d', padding: '4px 10px', fontSize: '13px' }} onClick={() => navigate('/debt-management')}>← จัดการยอดค้าง</button>
                <h1 style={{ margin: 0, fontSize: '18px' }}>ลูกค้าที่ค้างได้</h1>
            </div>

            <form onSubmit={e => { e.preventDefault(); load(query); }} style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
                <input
                    type="text"
                    value={query}
                    onChange={e => setQuery(e.target.value)}
                    placeholder="ค้นชื่อร้าน / ชื่อลูกค้า / รหัส (เว้นว่าง = แสดงเฉพาะร้านที่ค้างได้)"
                    style={{ flex: 1, padding: '6px 10px', borderRadius: '4px', border: '1px solid #ced4da' }}
                />
                <button type="submit" className="btc-btn" style={{ padding: '6px 14px' }}>ค้นหา</button>
            </form>

            {error && <p className="error">{error}</p>}
            {loading && <p style={{ color: '#6c757d' }}>กำลังโหลด...</p>}

            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px', background: '#fff' }}>
                <thead>
                    <tr>
                        <th style={{ ...headerStyle, textAlign: 'left' }}>ร้าน</th>
                        <th style={{ ...headerStyle, textAlign: 'left' }}>ตั้งค่าล่าสุดโดย</th>
                        <th style={{ ...headerStyle, textAlign: 'center', width: 120 }}>ค้างได้</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map(r => (
                        <tr key={r.customerUid}>
                            <td style={rowStyle}><CustomerLink name={r.storeName || r.customerName} code={r.customerUid} /></td>
                            <td style={rowStyle}>{r.creditUpdatedBy ? `${r.creditUpdatedBy} · ${String(r.creditUpdatedAt || '').replace('T', ' ').slice(0, 16)}` : '-'}</td>
                            <td style={{ ...rowStyle, textAlign: 'center' }}>
                                <label style={{ display: 'inline-flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
                                    <input
                                        type="checkbox"
                                        role="switch"
                                        checked={!!r.creditAllowed}
                                        disabled={busyUid === r.customerUid}
                                        onChange={() => toggle(r)}
                                    />
                                    {r.creditAllowed ? 'ค้างได้' : 'ไม่ได้'}
                                </label>
                            </td>
                        </tr>
                    ))}
                    {rows.length === 0 && !loading && !error && (
                        <tr><td colSpan="4" style={{ ...rowStyle, textAlign: 'center', color: '#adb5bd' }}>
                            {query.trim() ? 'ไม่พบร้านที่ค้นหา' : 'ยังไม่มีร้านที่ค้างได้ — พิมพ์ชื่อร้านเพื่อค้นหาแล้วเปิดสวิตช์'}
                        </td></tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default CreditCustomers;
